import { DocLink } from "../DocLink";
import { DocHeading, DocList, DocNextLink, DocPage, DocParagraph } from "../DocElements";

export function OverviewPage() {
	return (
		<DocPage title="概要">
			<DocParagraph>
				Izanagiは製造業に特化したAIプラットフォームです。AIエンジニアではない方でも、Izanagiのエージェントを活かして、工程解析・モデル学習から実機を動かすところまでできます。
			</DocParagraph>

			<DocHeading id="getting-started">まずはここから</DocHeading>
			<DocParagraph>
				Izanagiは「エージェントセントリック」（エージェント中心）なので、最初の一歩はエージェントの作成です。
			</DocParagraph>
			<DocList ordered>
				<li>
					<DocLink href="/">Izanagiのアプリ</DocLink>
					を開く
				</li>
				<li>
					新規プロジェクトを作成する（プロジェクト名は取り組むタスクに合わせて付けてください）
				</li>
				<li>そのプロジェクトの配下にエージェントを作成する</li>
			</DocList>
			<DocParagraph>
				作成したエージェントは、それぞれ専用の「環境」（CPU・ディスク、必要に応じてGPU）で動きます。作業はこのエージェントとのやり取りを通じて進めます。環境はエージェントごとに分かれていて、他のエージェントの影響を受けないので安心です。
			</DocParagraph>
			<DocNextLink to="/docs/chat">チャットを始める</DocNextLink>
		</DocPage>
	);
}
